/**
 * Date year limit helper
 * A native <input type="date"> lets the user type a year of up to six digits (Chrome allows
 * years up to 275760), and the browser reports that as a value such as "20261-10-29". A year
 * is four digits at most, so such a value is rejected before it reaches the form state.
 */

/**
 * True when a native date value has a year longer than four digits.
 * Accepts the "YYYY-MM-DD" format a date input reports; an empty or partial value returns false.
 */
export function hasOversizedYear(value: string): boolean {
  return /^\d{5,}-/.test(value);
}
